import AboutImage from "../../assets/about.png";
import CV from "../../assets/cv.pdf";
import { HiDownload } from "react-icons/hi";
import Card from "../../components/Card.jsx";
import data from "./data";
import "./about.css";

const About = () => {
  return (
    <section id="about" data-aos="fade-in">
      <div className="container about__container">
        <div className="about__left">
          <div className="about__portrait">
            <img src={AboutImage} alt="About Me" />
          </div>
        </div>
        <div className="about__right">
          <h2>About Me</h2>
          <div className="about__cards">
            {data.map((item) => (
              <Card key={item.id} className="about__card">
                <span className="about__card-icon">{item.icon}</span>
                <h5>{item.title}</h5>
                <small>{item.desc}</small>
              </Card>
            ))}
          </div>
          <p>
            "My journey into tech started with a curiosity for how things work,
            which quickly evolved into a passion for Web Development. I
            specialize in building responsive, reactive interfaces using React
            and modern CSS. With a strong focus on UI/UX, I don't just build
            features; I build experiences that solve real problems. As an
            ambitious learner, I am constantly pushing my boundaries to master
            new technologies. I am now seeking a role where I can contribute my
            dual mindset of design and development to create impactful digital
            products."
          </p>
          <a href={CV} download className="btn primary">
            Download CV
            <HiDownload />
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
